import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import RadioLive from "@/pages/RadioLive";
import RadioLibrary from "@/pages/RadioLibrary";
import TVLive from "@/pages/TVLive";
import TVLibrary from "@/pages/TVLibrary";
import InstagramFeed from "@/pages/InstagramFeed";
import CidadaoPanel from "@/pages/CidadaoPanel";
import ComplaintForm from "@/pages/ComplaintForm";
import ReportForm from "@/pages/ReportForm";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAds from "@/pages/admin/AdminAds";
import AdminRadio from "@/pages/admin/AdminRadio";
import AdminTV from "@/pages/admin/AdminTV";
import AdminPolls from "@/pages/admin/AdminPolls";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminMusic from "@/pages/admin/AdminMusic";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminInstagram from "@/pages/admin/AdminInstagram";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminEpisodes from "@/pages/admin/AdminEpisodes";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import MusicPlaylist from "@/pages/MusicPlaylist";
import { AudioProvider } from "@/context/AudioContext";
import { AuthProvider } from "@/context/AuthContext";
import { VideoPlayerProvider } from "@/context/VideoPlayerContext";
import GlobalVideoPlayer from "@/components/GlobalVideoPlayer";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AudioProvider>
          <VideoPlayerProvider>
            <BrowserRouter>
              <Routes>
                {/* Public app */}
                <Route element={<AppLayout />}>
                  <Route path="/" element={<RadioLive />} />
                  <Route path="/radio/biblioteca" element={<RadioLibrary />} />
                  <Route path="/tv" element={<TVLive />} />
                  <Route path="/tv/biblioteca" element={<TVLibrary />} />
                  <Route path="/instagram" element={<InstagramFeed />} />
                  <Route path="/musicas" element={<MusicPlaylist />} />
                  <Route path="/contato" element={<CidadaoPanel />} />
                  <Route path="/contato/reclamacao" element={<ComplaintForm />} />
                  <Route path="/contato/reportagem" element={<ReportForm />} />
                  <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
                </Route>

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="anuncios" element={<AdminAds />} />
                  <Route path="radio" element={<AdminRadio />} />
                  <Route path="tv" element={<AdminTV />} />
                  <Route path="musicas" element={<AdminMusic />} />
                  <Route path="enquetes" element={<AdminPolls />} />
                  <Route path="mensagens" element={<AdminMessages />} />
                  <Route path="instagram" element={<AdminInstagram />} />
                  <Route path="notificacoes" element={<AdminNotifications />} />
                  <Route path="episodios" element={<AdminEpisodes />} />
                  <Route path="configuracoes" element={<AdminSettings />} />
                </Route>
              </Routes>
              {/* Persistent floating YouTube player — survives route changes */}
              <GlobalVideoPlayer />
            </BrowserRouter>
          </VideoPlayerProvider>
        </AudioProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
